"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultHeaders = exports.RequestType = exports.HttpMethod = exports.ENV_CONFIGS = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
const ENV_CONFIGS = exports.ENV_CONFIGS = {
  [_acsScWebPlatformApi.ENVS.QA]: {
    ISSUES: "/construction/issues-qa/v1"
  },
  [_acsScWebPlatformApi.ENVS.STAGING]: {
    ISSUES: "/construction/issues-stg/v1"
  },
  [_acsScWebPlatformApi.ENVS.PRODUCTION]: {
    ISSUES: "/construction/issues/v1"
  }
};
const defaultHeaders = exports.defaultHeaders = {
  "Content-Type": "application/vnd.api+json"
};
let HttpMethod = exports.HttpMethod = /*#__PURE__*/function (HttpMethod) {
  HttpMethod["Get"] = "GET";
  HttpMethod["Post"] = "POST";
  HttpMethod["Delete"] = "DELETE";
  HttpMethod["Patch"] = "PATCH";
  HttpMethod["Put"] = "PUT";
  return HttpMethod;
}({});
let RequestType = exports.RequestType = /*#__PURE__*/function (RequestType) {
  RequestType["Query"] = "query";
  RequestType["Mutation"] = "mutation";
  return RequestType;
}({});
//# sourceMappingURL=constants.js.map